import { render, staticRenderFns } from "./FormularioPQR.vue?vue&type=template&id=5689e034&"
import script from "./FormularioPQR.vue?vue&type=script&lang=js&"
export * from "./FormularioPQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports